module.exports = __webpack_public_path__ + "img/alert_info_icon.37ef8260.svg";